import { createFileRoute } from '@tanstack/react-router';

import { automaticPixListSearch, bankAccountAutomaticPixPendingScreen, loadBankAccountMessages, loadBankAccountScreens } from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

// Autorizações pendentes do Pix Automático (`router.tsx:537-542`).
export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes')({
  validateSearch: automaticPixListSearch,
  staticData: { screen: bankAccountAutomaticPixPendingScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountAutomaticPixPendingScreen'),
});
